/**
 * 會員資訊 (租用人)
 * @typedef {Object} MemberInfo
 * @property {number|null} memberID
 * @property {string|null} memberNo
 * @property {string|null} memberPhone
 * @property {string|null} memberEmail
 * @property {string|null} memberAddress
 * @property {string|null} memberIdentityNumber
 */

/** @type {MemberInfo} */
export const initMemberState = {
	memberID: null,
	memberNo: null,
	memberPhone: null,
	memberEmail: null,
	memberAddress: null,
	memberIdentityNumber: null,
};

/**
 * 主要承租資訊
 * @typedef {Object} MainSection
 * @property {number|null} monthFee
 * @property {string|null} reviewStartDate 審閱期開始日
 * @property {string|null} reviewEndDate 審閱期最後一日
 */

/** @type {MainSection} */
export const initMainSectionState = {
	monthFee: null,
	reviewStartDate: null,
	reviewEndDate: null,
};

/**
 * 費用資訊
 * @typedef {Object} FeeSection
 * @property {number|null} firstMonthFee
 * @property {number|null} setupFee
 * @property {number|null} trainingFee
 */

/** @type {FeeSection} */
export const initFeeSectionState = {
	firstMonthFee: null,
	setupFee: null,
	trainingFee: null,
};